import { CoreDataPoint } from "../../../Components/Shared/CoreComponents";

export enum DynamicAggregateType {
    Count = 'Count',
    Sum = 'Sum',
    Avg = 'Avg',
    Min = 'Min',
    Max = 'Max'
}

export default interface AdHocReportAggregateModel {
    coreTypeID: number;
    aggregateType: DynamicAggregateType;
    aggregatedCoreDataPointModel: CoreDataPoint;
    aggregateColumnAlias: string;
}
